export default class Cookie {

  constructor(debug = false) {

    this.debug = debug;
    if (this.debug) console.log('Cookie init');

    if (this.setVars()) {
      if (this.debug) console.log('Cookie vars init done');
      this.setEvents();
    }
  }

  setVars()
  {
    this.cookieEl = document.querySelector('.jsCookie');
    if (!this.cookieEl) return false;

    this.buttonEl = document.querySelector('[data-cookie-button]');
    if (!this.buttonEl) return false;

    return true;
  }

  setEvents()
  {
    this.cookieEl.addEventListener('click', (e) => {
      e.preventDefault();

      this.onClick();
    });
  }

  onClick()
  {
    this.setCookie('cookieInfoAcknowledged', true, 7);
    this.cookieEl.classList.remove('active');
  }


   
  setCookie(name, value, days)
  {
    let expires = '';

    if (days) {
      const date = new Date();
       
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }


   
  getCookie(name)
  {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

   
  eraseCookie(name)
  {
    this.setCookie(name, '', -1);
  }
}
